// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"93":"list","180":"story"}[chunkId] + "-" + {"93":"2f3dd24979236355e978","180":"a062d137b2cd88ee58cc"}[chunkId] + ".css";
};